// extracted by mini-css-extract-plugin
export default {"actionMenuContainer":"styles_actionMenuContainer__kWo2M","defaultButtons":"styles_defaultButtons__cFaDM"};